import React from 'react';
import Create from 'containers/rest/Create';
import i18next from 'i18next';
import Form from '../components/Form';
import CreateEditStyles from '../styles';

const UsersCreate = (props) => {
  const breadcrumbCustom = [
    {
      title: i18next.t('sideBar.settings'),
      path: '/config',
    },
    {
      title: i18next.t('users.header'),
      path: '/config/users',
    },
    {
      title: i18next.t('users.createPage'),
    },
  ];

  return (
    <CreateEditStyles>
      <Create
        {...props}
        resource="users"
        breadcrumbCustom={breadcrumbCustom}
        header="users.createPage"
        isResetStyle
        okText="button.createUser"
      >
        <div>
          <div className="create-user-title">
            {i18next.t('users.addUserInformation')}
          </div>
          <Form />
        </div>
      </Create>
    </CreateEditStyles>
  );
};

export default UsersCreate;
